<template>
  <div class="container">
    <img src="../../assets/images/pageHome/leftBg.png" alt="" class="leftBg" />
    <header>
      <div class="header_content">云尚益家社会组织助力共富应用</div>
      <div class="pageTime">{{ nowTime }}</div>
    </header>
    <main>
      <div class="left_box">
        <div class="orgClickBoxTitle" @click="toGovCont">
          <img src="../../assets/images/pageHome/toMore.png" alt="" />
        </div>
        <div class="toServeClass" @click="toOrgTeam">
          <img src="../../assets/images/pageHome/toMore.png" alt="" />
        </div>
        <div class="toOrgTeam" @click="toOrgTeam">
          <img src="../../assets/images/pageHome/toMore.png" alt="" />
        </div>
        <div class="box_one">
          <div class="titlePsotion">
            <titleBox title="组织总览" />
          </div>
          <div class="positionFunc">
            <msgTitle :dataList="allOrgNum" />
            <div class="jqNUm">
              <div
                class="itemBox"
                v-for="(item, index) in jqData"
                :key="item + index"
                @click="toOrgTeam(item, 1)"
              >
                <div class="jq_title">{{ item.title }}</div>
                <div class="jq_value">{{ item.value }}个</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box_two">
          <div class="titlePsotion">
            <titleBox title="社会组织类型" />
          </div>
          <div class="mainPosition">
            <div class="menuList">
              <div
                class="mentItem"
                v-for="(item, index) in orgClass"
                :key="item + index"
                @click="toOrgTeam(item, 2)"
              >
                <div class="color" :style="{ background: item.color }"></div>
                <div class="title">{{ item.title }}</div>
                <div class="num">{{ item.num }}</div>
              </div>
            </div>
          </div>
          <div class="echartBox">
            <chartOne :dataObj="pieChartList" />
          </div>
        </div>
        <div class="box_three">
          <div class="titlePsotion">
            <titleBox title="社会组织发展情况" />
          </div>
          <!-- 雷达图 -->
          <div class="echartBox" @click="ldt">
            <RadarEchart :value="radarValue" ref="radarEchart" />
          </div>
          <div class="titleList">
            <div
              class="titleItem"
              v-for="(item, index) in list"
              :key="item + index"
            >
              <div class="listItem" @click="clickTitle(index,item.orgId)">
                <img
                  src="../../assets/images/pageHome/gold.png"
                  class="itemImage"
                  v-if="item.src != '' && index == 0"
                />
                <img
                  src="../../assets/images/pageHome/yin.png"
                  class="itemImage"
                  v-if="item.src != '' && index == 1"
                />
                <img
                  src="../../assets/images/pageHome/tong.png"
                  class="itemImage"
                  v-if="item.src != '' && index == 2"
                />
                <div
                  v-if="index == 3 || index == 4"
                  style="
                    margin-right: 10px;
                    width: 17px;
                    height: 20px;
                    text-align: center;
                    flex-shrink: 0;
                  "
                >
                  {{ index + 1 }}
                </div>
                <div class="title">{{ item.orgName }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box_four">
          <div class="titlePsotion">
            <titleBox title="服务类型" />
          </div>
          <div class="ecahrt">
            <boxFourEchart
              :dataObj="serveClass"
              ref="leftFourEcahrt"
              :allClassArr="allClassArr"
            />
          </div>
        </div>
      </div>
      <div class="center_box">
        <div class="map_box"></div>
        <!-- <div class="bottom_box"> -->
        <!-- <div class="box_one"> -->

        <div class="centerContainer">
          <div class="titlePsotion">
            <titleBox title="供需分析" width="736px" />
          </div>
          <div class="center_nav">
            <div
              :class="[selectIndex == index ? 'select' : '', 'item']"
              v-for="(item, index) in navlist1"
              :key="index"
              @click="select(index)"
            >
              {{ item.dictName }}
            </div>
          </div>

          <div class="centerCon">
            <div
              class="center_item"
              v-for="(item, index) in supplyArr1"
              :key="index"
            >
              <div
                class="centtit"
                :style="{ width: item.dictName.length >= 5 ? '45px' : '28px' }"
              >
                {{ item.dictName }}
              </div>
              <div class="center_right" :key="index">
                <div
                  class="right1"
                  
                >
                  <span class="text" >组织数量</span>
                  <span class="span" :style="{  width:item.needCount<20 ? item.needCount * 5 + 'PX':'' }">{{ item.needCount }}</span>
                </div>
                <div
                  class="right2"
                  
                >
                  <span class="text">需求数量</span>
                  <span class="span" :style="{ width:item.orgCount<20 ? item.orgCount * 5 + 'PX':'' }">{{ item.orgCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
        <!-- </div> -->
      </div>
      <div class="right_box">
        <div class="toProject" @click="toProjectList">
          <img src="../../assets/images/pageHome/toMore.png" alt="" />
        </div>
        <msgTitle1 :message='pvCount' />
        <div class="box_one">
          <qualityService />
        </div>
        <div class="box_two">
          <schedule title="项目进度" />
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import baseUrl from "../../config/config";
import titleBox from "./components/titleBox.vue";
import msgTitle from "./components/msgTitle.vue";
import msgTitle1 from "./components/msgTitle1.vue";
import chartOne from "../../components/CentetLeft1.vue";
import RadarEchart from "../../components/RadarEchart.vue";
import boxFourEchart from "../../components/CenterCenter2.vue";
import qualityService from "./components/qualityService.vue";
import schedule from "./components/schedule.vue";
import axios from "axios";
import { kyyBigScreen } from "../../config/api";
export default {
  components: {
    titleBox,
    msgTitle,
    chartOne,
    RadarEchart,
    boxFourEchart,
    qualityService,
    schedule,
    msgTitle1,
  },
  data() {
    return {
      pvCount:'',
      list: [],
      baseUrl: baseUrl,

      allClassArr: [],
      // 服务类型
      serveClass: [],
      // 饼图传入数据
      pieChartList: [],
      allOrgNum: [],
      // 左侧数据对象
      leftMsgObj: {},
      //  雷达图
      radarValue: [],
      selectIndex: 0,
      navlist: [
        { name: "社区自治类", id: 0 },
        { name: "社区平安类", id: 1 },
        { name: "社区服务类", id: 2 },
        { name: "社区文体类", id: 3 },
        { name: "组织服务类", id: 4 },
      ],
      navlist1: [], ////////////////////////////////////////////
      supplyArr: [],
      supplyArr1: [],////////////////////////////
      dataArr1: [],
      dataArr: [
        {
          type: "社区自治类",
          id: 0,
          serviceType: [
            {
              name: "志愿服务",
              orgNum: 32,
              demand: 43,
            },
            {
              name: "社区矫正",
              orgNum: 27,
              demand: 50,
            },
            {
              name: "社会融入",
              orgNum: 57,
              demand: 68,
            },
            {
              name: "社区营造",
              orgNum: 43,
              demand: 50,
            },
          ],
        },
        {
          type: "社区平安类",
          id: 0,
          serviceType: [
            {
              name: "治安巡逻",
              orgNum: 27,
              demand: 50,
            },
            {
              name: "环境保护",
              orgNum: 57,
              demand: 68,
            },
            {
              name: "矛盾调解",
              orgNum: 32,
              demand: 43,
            },
          ],
        },
        {
          type: "社区服务类",
          id: 0,
          serviceType: [
            {
              name: "法律服务",
              orgNum: 43,
              demand: 50,
            },
            {
              name: "扶老助残",
              orgNum: 32,
              demand: 43,
            },
            {
              name: "社会救助",
              orgNum: 27,
              demand: 50,
            },
            {
              name: "劳动就业",
              orgNum: 32,
              demand: 43,
            },
            {
              name: "邻里帮扶",
              orgNum: 57,
              demand: 68,
            },
            {
              name: "权益维护",
              orgNum: 27,
              demand: 50,
            },
            {
              name: "慈善公益",
              orgNum: 36,
              demand: 49,
            },
            {
              name: "医疗卫生",
              orgNum: 32,
              demand: 43,
            },
            {
              name: "心理疏导",
              orgNum: 57,
              demand: 68,
            },
            {
              name: "妇女儿童",
              orgNum: 27,
              demand: 50,
            },
          ],
        },
        {
          type: "社区文体类",
          id: 0,
          serviceType: [
            {
              name: "科普宣传",
              orgNum: 27,
              demand: 50,
            },
            {
              name: "文体教育",
              orgNum: 32,
              demand: 43,
            },
          ],
        },
        {
          type: "其他类",
          id: 0,
          serviceType: [
            {
              name: "社会组织发展",
              orgNum: 32,
              demand: 43,
            },
            {
              name: "民生服务",
              orgNum: 57,
              demand: 68,
            },

            {
              name: "第三方服务",
              orgNum: 43,
              demand: 50,
            },
            {
              name: "党建服务",
              orgNum: 27,
              demand: 54,
            },
          ],
        },
      ],
      //left title
      jqData: [
        {
          title: "5A",
          value: "131",
          titleId: "1",
        },
        {
          title: "4A",
          value: "180",
          titleId: "2",
        },
        {
          title: "3A",
          value: "201",
          titleId: "3",
        },
        {
          title: "其他",
          value: "230",
          titleId: "4",
        },
      ],
      orgClass: [
        // {
        //   color: "#E9A933",
        //   title: "社区社会组织",
        //   num: "339",
        // },
        // {
        //   color: "#BD5E26",
        //   title: "民非",
        //   num: "210",
        // },
        // {
        //   color: "#C44209",
        //   title: "社会团体",
        //   num: "181",
        // },
        // {
        //   color: "#1A49FF",
        //   title: "基金会",
        //   num: "21",
        // },
      ],
      box_leftList: [
        {
          name: "凯旋“红马甲”志愿者协会",
          src: "../../assets/images/pageHome/gold.png",
        },
        {
          name: "华语之声凯旋服务站",
          src: "../../assets/images/pageHome/yin.png",
        },
        {
          name: "凯旋民商事调解法律服务中心",
          src: "../../assets/images/pageHome/tong.png",
        },
        {
          name: "杭州健协社区服务中心",
          src: "",
        },
        {
          name: "海善公益",
          src: "",
        },
      ],
      nowTime: "",
      radarValueArr: [],
      timeId: null,
      ld:'',
    };
  },
  created() {
    // this.supplyArr1 = res.data.dictOrgNeedVo[0].subDict
    this.nowTimes();
    this.getRadarDetail();
    // this.getList()
  },
  beforeDestroy() {},
  methods: {
    ldt(){
        this.$router.push({
          path: "/socialorgDetails",
          query: {
            id: this.ld,
          },
        });
    },
    //列表
    // getList () {
    //   console.log(baseUrl, 'baseUrl')
    //   // this.listLoading = true
    //   let that = this
    //   axios.post(this.baseUrl.baseUrl + '/system/wechat/kyyOrganizationPcController/selectKyyOrgDevelopmentList', {
    //     // page: this.page,
    //     // indexNumberType: this.indexNumberType,
    //     // street: this.street,
    //     limit: 5
    //   })
    //     .then(function (response) {
    //       // console.log(response.data.lastPage, 'list')
    //       // console.log(response, '列表');
    //       // that.total = response.data.total
    //       // console.log(' that.total=====》', response.data.total)
    //       that.list = response.data.list
    //       // console.log(response.data.lastPage, 'list')
    //     })
    //     // .catch(function (err) {
    //     //   console.log(err);
    //     // });
    // },

    // 去取公益
    toGy() {
      this.$router.push({
        path: "/league",
      });
    },
    // to 社会组织列表
    toOrgTeam(item, type) {
      console.log(item);
      console.log(type);
      if (type == 1) {
        //  5A景区
        this.$router.push({
          path: "/orgTeam",
          query: {
            typeName: item.titleId,
          },
        });
      } else if (type == 2) {
        this.$router.push({
          path: "/orgTeam",
          query: {
            typeId: item.typeId,
            id: item.id,
          },
        });
      } else {
        this.$router.push("/orgTeam");
      }
    },
    // 社会组织发展情况
    toGovCont() {
      this.$router.push("/govCont");
      console.log("点击");
    },
    //  服务类型
    toSeverClass() {
      this.$router.push("/");
    },
    toServePointsList() {
      this.$router.push("/servers");
    },
    // 项目 列表
    toProjectList() {
      this.$router.push("/project");
    },
    // 点击雷达图旁边数据
    clickTitle(index,id) {
      
      this.ld = id
      console.log('id',this.ld)
      this.radarValue = [];
      console.log(index);
      // let arr = []
      let obj = [];
      obj = Object.values(this.radarValueArr[index].itemVo);
      // console.log(obj);
      let arr = obj.map((item) => {
        return parseInt(item);
      });

      // console.log(arr);
      this.radarValue = arr;
      this.$nextTick(() => {
        this.$refs.radarEchart.renderEchartsMethod();
      });
    },

    async getRadarDetail() {
      const res = await axios.post(kyyBigScreen);
      // console.log(res.data)
      this.leftMsgObj = res.data;
      if (res.rtnCode == "0000") {
        this.list = res.data.pageinfo; ///////////////////////////////////////////////////////////////////
        this.navlist1 = res.data.dictOrgNeedVo;
        this.ld = this.list[0].orgId
        if (this.selectIndex == 0) {
          this.supplyArr1 = res.data.dictOrgNeedVo[0].subDict;
        }
        if (this.selectIndex == 1) {
          this.supplyArr1 = res.data.dictOrgNeedVo[1].subDict;
        }
        if (this.selectIndex == 2) {
          this.supplyArr1 = res.data.dictOrgNeedVo[2].subDict;
        }
        if (this.selectIndex == 3) {
          this.supplyArr1 = res.data.dictOrgNeedVo[3].subDict;
        }
        if (this.selectIndex == 4) {
          this.supplyArr1 = res.data.dictOrgNeedVo[4].subDict;
        }

        // this.supplyArr = this.dataArr[0].serviceType;
        // 缓存数据
        this.allClassArr = res.data.kyyCategoryStaReturnVo.dictVoList;
        // 雷达图
        this.radarValueArr = res.data.pageinfo;
        this.radarValue = [];
        let obj = [];
        obj = Object.values(this.radarValueArr[0].itemVo);
        let arr = obj.map((item) => {
          return parseInt(item);
        });
        this.radarValue = arr;
        this.jqData[0].value = res.data.kyyOrgStaVo.org5ACount;
        this.jqData[1].value = res.data.kyyOrgStaVo.org4Acount;
        this.jqData[2].value = res.data.kyyOrgStaVo.org3ACount;
        this.jqData[3].value = res.data.kyyOrgStaVo.orgOtherCount;
        this.box_leftList.map((item, index) => {
          item.name = res.data.pageinfo[index].orgName;
          return item;
        });
        // 组织总览  社会组织 数量
        this.allOrgNum = [
          {
            name: "社会组织",
            num: res.data.kyyOrgStaVo.orgCount,
          },
          {
            name: "社会组织党组织",
            num: res.data.kyyOrgStaVo.orgPartyCount,
          },
          {
            name: "公益党建联盟",
            num: res.data.kyyOrgStaVo.orgCharitableCount,
          },
        ];
        //社会组织 类型
        this.orgClass = [
          {
            color: "#E9A933",
            title: "社区社会组织",
            num: res.data.kyyOrgTypeStaReturnVo.count[1],
            typeId: 1,
            id: 1,
          },
          {
            color: "#BD5E26",
            title: "民非",
            num: res.data.kyyOrgTypeStaReturnVo.count[0],
            typeId: 1,
            id: 0,
          },
          {
            color: "#C44209",
            title: "社会团体",
            num: res.data.kyyOrgTypeStaReturnVo.count[3],
            typeId: 2,
            id: 3,
          },
          {
            color: "#1A49FF",
            title: "基金会",
            num: res.data.kyyOrgTypeStaReturnVo.count[2],
            typeId: 1,
            id: 2,
          },
        ];
        // 饼图
        this.pieChartList = [
          { name: "民非", y: res.data.kyyOrgTypeStaReturnVo.count[0] },
          { name: "社会团体", y: res.data.kyyOrgTypeStaReturnVo.count[1] },
          { name: "基金会", y: res.data.kyyOrgTypeStaReturnVo.count[2] },
          { name: "社区社会组织", y: res.data.kyyOrgTypeStaReturnVo.count[3] },
        ];
        // 服务类型
        this.serveClass = res.data.kyyCategoryStaReturnVo;
        this.pvCount = res.data.pvCount,// 访问人数
        console.log(this.serveClass);
        this.$nextTick(() => {
          this.$refs.radarEchart.renderEchartsMethod();
          this.$refs.leftFourEcahrt.renderEchartsMethod();
        });
      }
    },
    select(index) {
      this.selectIndex = index;
      this.getRadarDetail();
      // this.supplyArr = this.dataArr[index].serviceType;
      // console.log("this.supplyArr=>", this.supplyArr);
      // this.supplyArr1 = res.data.dictOrgNeedVo[index].subDict
    },
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      // let ss =
      //   new Date(timeStamp).getSeconds() < 10
      //     ? "0" + new Date(timeStamp).getSeconds()
      //     : new Date(timeStamp).getSeconds();
      let week = new Date(timeStamp).getDay();
      let weeks = ["日", "一", "二", "三", "四", "五", "六"];
      let getWeek = "星期" + weeks[week];
      this.nowTime =
        year +
        "-" +
        month +
        "-" +
        date +
        "   " +
        getWeek +
        "   " +
        hh +
        ":" +
        mm;
    },
    nowTimes() {
      this.timeFormate(new Date());
      setInterval(this.nowTimes, 60000);
      setInterval(() => {
            this.getRadarDetail()
        }, 5000)
      this.clear();
    },
    clear() {
      clearInterval(this.nowTimes);
      this.nowTimes = null;
    },

  },
};
</script>
<style lang="less" scoped>
@leftBoxWidth: 30%; // 左边盒子宽度
@rightBoxWidth: 29%; //右边盒子 宽度
@centerWidth: 40%; //  中间盒子宽度
.container {
  // default
  // overflow: hidden;
  width: 100vw;
  height: 100vh;
  background-color: #000000;

  .leftBg {
    width: 27%;
    height: 85%;
    position: absolute;
    top: 12%;
    left: 1%;
  }
  .rightBg {
    display: inline-block;
    position: absolute;
    top: -0.5%;
    right: -1%;
  }
  .centerBg {
    position: absolute;
    bottom: 6px;
    left: 25.3%;
  }
  header {
    cursor: default;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 8%;
    width: 100%;
    background: url("../../assets/images/pageHome/topTitle.png") no-repeat
      center/100% 100%;
    .header_content {
      letter-spacing: 5px;
      transform: translateY(-1px);
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #fff;
      // background: linear-gradient(to right, #be8840, #ffe01a);
      // -webkit-background-clip: text;
      // color: transparent;
    }
    .pageTime {
      position: absolute;
      top: 2.7%;
      right: 10px;
      font-size: 22px;
      font-family: Source Han Sans CN;
      // font-weight: bold;
      color: #fff;
    }
  }
  .orgClickBox {
    position: absolute;
    width: @leftBoxWidth / 5;
    height: 110px;
    top: 59%;
    z-index: 1000;
    cursor: pointer;
    left: 90px;
  }
  .orgClickBoxTitle {
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    width: @leftBoxWidth / 1.1;
    height: 40px;
    top: 44.8%;
    left: 380px;
    z-index: 1000;
    img {
      margin-top: 10px;
      display: inline-block;
      width: 50px;
      height: 14px;
      z-index: 1000;
      margin-right: 42px;
    }
  }
  .toServeClass {
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    width: @leftBoxWidth / 1.1;
    height: 40px;
    top: 72.7%;
    left: 380px;
    z-index: 10000000;
    // background: pink;
    img {
      display: inline-block;
      margin-top: 10px;
      width: 50px;
      height: 14px;
      z-index: 1000;
      margin-right: 42px;
      z-index: 10000000;
    }
  }
  .toOrgTeam {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    width: @leftBoxWidth / 1.1;
    height: 40px;
    top: 19.5%;
    left: 380px;
    z-index: 1000;
    cursor: pointer;
    // background: pink;
    img {
      display: inline-block;
      width: 50px;
      height: 14px;
      z-index: 1000;
      margin-top: 10px;
      margin-right: 42px;
    }
  }
  main {
    display: flex;
    margin-top: 0%;
    height: 89%;
    width: 97%;
    margin-left: 1%;
    //左侧 盒子
    .left_box {
      transform: translateX(10px);
      height: 100%;
      width: @leftBoxWidth;
      // border: 1px solid RGBA(215, 117, 19, 0.2);
      // box-shadow: 0px 6px 168px 15px RGBA(215, 117, 19, 0.1) inset;
      .box_one {
        position: relative;
        height: 20%;
        width: 100%;
        .titlePsotion {
          width: 100%;
          position: absolute;
          top: 4%;
          left: -2%;
        }
        .positionFunc {
          // z-index: 1000;
          width: 100%;
          position: absolute;
          top: 30%;
        }
        .jqNUm {
          cursor: pointer;
          width: 90%;
          display: flex;
          justify-content: space-between;
          color: #ffff;
          .itemBox {
            z-index: 10000;
            display: flex;
            justify-content: space-around;
            align-items: center;
            background: url("../../../src/assets/images/pageHome/5Abg.png")
              no-repeat center/100% 100%;
            width: 136px;
            height: 32px;
            .jq_title {
              color: #fff;
              font-size: 16px;
              font-weight: bold;
              transform: translateY(-2px);
            }
            .jq_value {
              transform: translateY(-2px);
            }
            .jqNUm {
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #ffffff;
            }
          }
        }
      }
      .box_two {
        position: relative;
        height: 26.5%;
        width: 100%;
        z-index: 100;
        .titlePsotion {
          width: 100%;
          position: absolute;
          top: 1.5%;
          left: -2%;
          z-index: -1;
        }
        .mainPosition {
          position: absolute;
          top: 15%;
          left: 3%;
          display: flex;
          justify-content: space-between;
          .menuList {
            cursor: pointer;
            color: #fff;
            transform: translateX(-10px);
            .mentItem {
              margin-top: 20px;
              display: flex;
              align-items: center;
              .color {
                width: 11px;
                height: 11px;
                border-radius: 50%;
                margin-top: 3px;
                margin-right: 10px;
              }
              .title {
                font-size: 16px;
                font-family: Source Han Sans CN;
                // font-weight: bold;
                margin-right: 10px;
              }
              .num {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #67d5f9;
              }
            }
          }
        }
        .echartBox {
          z-index: -1;
          width: 300px;
          height: 350px;
          position: absolute;
          right: 21%;
          top: -30%;
        }
        // background-color: aliceblue;
      }
      .box_three {
        cursor: pointer;
        position: relative;
        height: 26.5%;
        width: 100%;
        display: flex;
        justify-content: space-between;
        // background-color: palegreen;
        .titlePsotion {
          width: 100%;
          position: absolute;
          top: -10px;
          left: -2%;
          z-index: 11;
        }
        .echartBox {
          width: 50%;
          height: 200px;
          transform: translateX(-8px) translateY(-10px);
          z-index: 100;
        }
        .titleList {
          transform: translateX(-25%) translateY(-15px);
          margin-top: 48px;
          width: 40%;
          height: 100%;
          font-size: 13px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #fff;
          z-index: 1000;
          .titleItem {
            .listItem {
              display: flex;
              align-items: center;
              // margin-top: 9px;
              padding-top: 6px;
              padding-bottom: 6px;
              border-bottom: 1px solid rgba(11, 68, 102, 0.5);
              cursor: pointer;
              .itemImage {
                margin-right: 10px;
                display: inline-block;
                width: 17px;
                height: 20px;
              }
            }
          }
        }
      }
      .box_four {
        position: relative;
        height: 26.5%;
        width: 100%;
        // border: 1px solid red;
        // background-color: grey;
        .titlePsotion {
          width: 100%;
          position: absolute;
          top: 1.5%;
          left: -2%;
        }
        .ecahrt {
          // transform: translateX(-5%) translateY(10px);
          width: 100%;
          height: 246px;
          // overflow-x: scroll;
          // ::-webkit-scrollbar {
          //   display: none;
          // }
        }
      }
    }
    //  右侧盒子
    .right_box {
      transform: translateX(20px);
      position: relative;
      height: 100%;
      width: @rightBoxWidth;
      z-index: 10;
      background: url("../../assets/images/pageHome/leftBg.png") no-repeat
        center/100% 100%;
      padding-right: 10px;
      .toProject {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        position: absolute;
        width: 400px;
        height: 40px;
        top: 52.8%;
        right: -10px;
        z-index: 1000;
        cursor: pointer;
        // background: pink;
        img {
          display: inline-block;
          width: 50px;
          height: 14px;
          z-index: 1000;
          margin-right: 42px;
        }
      }
      .box_one {
        height: 42%;
        width: 100%;
        margin-top: 20px;
        // margin-bottom: 21px;
        // margin-top: 23px;
      }
      .box_two {
        height: 43%;
        width: 100%;
      }
    }
    // 中间盒子
    .center_box {
      height: 100%;
      // background: gold;
      width: @centerWidth;
      margin-left: 1%;
      margin-right: 1%;
      .map_box {
        cursor: default;
        width: 100%;
        height: 73%;
        // background-color: palegreen;
        background: url("../../assets/images/pageHome/centerMap.png") no-repeat
          center/100% 100%;
      }
      // .bottom_box {

      // display: none;
      // // opacity: 0.1;
      // cursor: pointer;
      // background: pink;
      // height: 23%;
      // // background-color: plum;
      // background-color: #000000;
      // display: flex;
      // flex-direction: column;
      // .box_one {
      //   height: 100%;
      //   position: relative;
      //   width: 100%;

      .centerContainer {
        position: relative;
        transform: translateY(35px) translateX(-10px);
        padding-left: 30px;
        display: flex;
        flex-direction: column;
        // margin-top: 70px;
        background: url("../../assets/images/pageHome/centerBg.png") no-repeat
          center/100% 100%;
        .titlePsotion {
          position: absolute;
          width: 100%;
          left: -1px;
          top: -36px;
        }
      }
      .center_nav {
        cursor: pointer;
        width: 100%;
        height: 38px;
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 14px;
        margin-bottom: 20px;
        z-index: 100;
        margin-left: 10px;
        .item {
          letter-spacing: 1.5px;
          margin-right: 40px;
          z-index: 100;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          // font-weight: bold;
          font-family: Source Han Sans CN;
        }
        .select {
          letter-spacing: 1.5px;
          color: #1293f0;
          font-size: 18px;
          font-family: Source Han Sans CN;
          border-bottom: 1px solid #1293f0;
          z-index: 100;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 400;
        }
      }
      .center_right {
        width: 165px;
        margin-left: 10px;
      }
      .span {
        margin-right: 5px;
      }
      .centerCon {
        width: 96%;
        // height: 130px;
        height: 170px;
        // padding: 10px 2%;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow-x: scroll;
      }
      // .centerCon::-webkit-scrollbar{
      //   display: none;
      // }
      // 滚动条宽度

      .centerCon::-webkit-scrollbar {
        /*滚动条整体样式*/
        // width: 10px;
        /*高宽分别对应横竖滚动条的尺寸*/
        height: 5px;
        background-color: rgba(18, 147, 240, 0.1);
      }

      .centerCon::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 6px;
        // box-shadow: inset 0 0 0px #efefef;
        // -webkit-box-shadow: inset 0 0 0px #efefef;
        /* background: rgba(102, 97, 97, 0.2); */
        background: #1293f0;
      }
      .center_item {
        display: flex;
        font-size: 14px;
        color: #fff;
        align-items: center;
        margin-bottom: 26px;
        margin-right: 55px;
      }
      .centtit {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 28px;
      }
      .right1 .text {
        float: left;
        display: inline-block;
        background: #1293f0;
        width: 60px;
        height: 14px;
        line-height: 14px;
        // border:1px solid lawngreen;
      }
      .right2 .text {
        float: left;;
        background: #c44209;
        width: 60px;
        height: 14px;
        line-height: 14px;
        // border:1px solid lawngreen;
      }
      .right1 .span{
        // width: 100px;
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        background: #1293f0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        -webkit-animation-name: "fadeInLeft"; /*动画名称，需要跟@keyframes定义的名称一致*/
        -webkit-animation-duration: 0.5s; /*动画持续的时间长*/
        -webkit-animation-iteration-count: 1; /*动画循环播放的次数为1 infinite为无限次*/
      }
      .right2 .span {
        // width: 100px;
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        background: #c44209;
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        -webkit-animation-name: "fadeInLeft"; /*动画名称，需要跟@keyframes定义的名称一致*/
        -webkit-animation-duration: 0.5s; /*动画持续的时间长*/
        -webkit-animation-iteration-count: 1; /*动画循环播放的次数为1 infinite为无限次*/
      }
      // }
      // }
    }
  }
}
</style>
